var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveIconCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "25.8px",
    height: "25.8px",
    viewBox: "0 0 25.8 25.8",
    style: {
      enableBackground: "new 0 0 25.8 25.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#E84B37;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12.9,
    cy: 12.9,
    r: 12.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "7.1,9.4 7.1,18.7 18.7,18.7 18.7,7.1 9.4,7.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "10.1,7.1 10.1,11.1 15.7,11.1 15.7,7.1  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11.7,
    y1: 8.5,
    x2: 11.7,
    y2: 9.3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "16.3,18.7 16.3,14.3 9.5,14.3 9.5,18.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "7.1,9.4 7.1,18.7 18.7,18.7 18.7,7.1 9.4,7.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "10.1,7.1 10.1,11.1 15.7,11.1 15.7,7.1  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11.7,
    y1: 8.5,
    x2: 11.7,
    y2: 9.3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "16.3,18.7 16.3,14.3 9.5,14.3 9.5,18.7  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIconCircle);
export default __webpack_public_path__ + "static/media/save-icon-circle.65f68fdb49b1b40f09f231fbaf56cf4e.svg";
export { ForwardRef as ReactComponent };